import React from 'react';
import Body from './Body';

const View = (props) => {
  const checkTags =
    props?.properties?.tags?.length > 0 || props?.subjects?.length > 0;

  return checkTags ? (
    <div className="block page-tag">
      <Body {...props} />
    </div>
  ) : (
    <></>
  );
};

export default View;
